import { mergeAttributes, Node } from '@tiptap/core';

export interface TableCaptionOptions {
  HTMLAttributes: Record<string, any>;
}

export const TableCaption = Node.create<TableCaptionOptions>({
  name: 'tableCaption',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      colspan: {
        default: 1,
        parseHTML: (element) => {
          const table = element.parentElement;
          if (table) {
            // Get the first tbody element in the table
            var tbody = table.getElementsByTagName('tbody')[0];

            // If there is no tbody, use the table directly
            var rows = tbody.rows;

            if (rows.length > 0) {
              // Get the first row of the tbody (or table)
              var firstRow = rows[0];

              // Get the number of cells (columns) in the first row
              var columnCount = firstRow.cells.length;

              return columnCount;
            }
          }
        },
      },
      rowspan: {
        default: 1,
      },
      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute('colwidth');
          const value = colwidth ? [parseInt(colwidth, 10)] : null;

          return value;
        },
      },
    };
  },

  content: 'block+',

  isolating: true,

  tableRole: 'cell',

  parseHTML() {
    return [{ tag: 'caption' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['td', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});
